export const ErrorVector = ({ alt }: { alt: string }) => (
    <svg
        width="160"
        height="160"
        viewBox="0 0 275 275"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
    >
        <title>{alt}</title>
        <path
            d="M252.19 144H241.86L236.89 131.48H208.9C209.34 105.59 211.98 81.61 216.72 60H80.86C80.46 63.92 80.1 67.89 79.76 71.88H40.59L45.56 84.41H95.07L100.04 96.94H78.05C78.05 97.1 78.03 97.26 78.02 97.42L77.83 96.94H18L22.97 109.47H40.6L45.57 122H77.19C77.08 127.4 77.02 132.83 77.02 138.32C77.02 156.29 77.57 173.69 78.62 190.53H55.04L60.01 203.06H45.06L50.03 215.59H216.38C214.05 204.77 212.26 193.36 211 181.4H189.24L184.27 168.87H201.65L196.68 156.34L257.17 156.52L252.2 143.99L252.19 144Z"
            fill="#DDDEE1"
        />
        <path
            d="M145.44 121.79C130.36 121.79 121.56 127.75 116.51 136.34C121.56 144.93 130.37 150.89 145.44 150.89V121.8V121.79Z"
            fill="white"
        />
        <path
            d="M145.44 150.89C160.52 150.89 169.32 144.93 174.37 136.34C169.32 127.75 160.51 121.79 145.44 121.79V150.88V150.89Z"
            fill="white"
        />
        <path
            d="M155.81 138.66C155.94 137.94 156.01 137.17 156.01 136.36C156.01 135.55 155.94 134.76 155.81 134.03C155.03 129.68 152 126.99 147.76 126.3C147.04 126.18 146.28 126.12 145.49 126.12C144.7 126.12 143.88 126.19 143.12 126.31C138.88 127.02 135.86 129.69 135.07 134.02C134.94 134.75 134.87 135.53 134.87 136.35C134.87 137.17 134.94 137.93 135.07 138.65C135.85 142.97 138.87 145.65 143.12 146.36C143.87 146.49 144.66 146.55 145.49 146.55C146.32 146.55 147.04 146.49 147.76 146.37C152.01 145.68 155.03 142.99 155.81 138.64V138.66Z"
            fill="#DDDEE1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120.9 156.68L165.78 111.8L169.98 116L125.1 160.88L120.9 156.68Z"
            fill="white"
        />
        <path
            d="M77.1799 122.001H106L101.03 109.471H77.1799V122.001Z"
            fill="#B7B9BE"
        />
        <path
            d="M81.11 215.601H109.93L104.96 203.061H80.22L81.11 215.601Z"
            fill="#B7B9BE"
        />
        <path
            d="M208.17 143.83H189.89L194.86 156.37H199.44H208.17V143.83Z"
            fill="#B7B9BE"
        />
    </svg>
);
